import React, { useState } from 'react';
import { Search } from "@mui/icons-material";
import { Box, TextField, Button, Typography, Autocomplete } from "@mui/material";
import { useSelector } from 'react-redux';
import { getRequest } from '../../globalhelper/helper';

export const FilterSection = ({ onSearch, extraActions }) => {
  const userData = useSelector(state => state.login?.userData || {});
  const tenants = userData.USR_Tenants || [];

  const [orgOptions, setOrgOptions] = useState([]);
  const [selectedTenant, setSelectedTenant] = useState(null);
  
  const [screenOptions, setScreenOptions] = useState([]);
  const [selectedOrg, setSelectedOrg] = useState(null);
  const [selectedScreen, setSelectedScreen] = useState(null);

  const handleTenantChange = (event, newValue) => {
    setSelectedTenant(newValue);
    setSelectedOrg(null);
    setSelectedScreen(null);
    setScreenOptions([]);
    console.log(newValue);

    if (newValue && typeof newValue !== 'string' && newValue.Tenant_ID) {
      getRequest(`api/edureka/getScreenMappingFiles?tenantId=${newValue.Tenant_ID}`)
        .then(res => {
          let data = res?.res?.data || res?.data || res;
          if (typeof data === 'string') {
            try { data = JSON.parse(data); } catch (e) {}
          }
          setScreenOptions(Array.isArray(data) ? data : []);
        })
        .catch(err => {
          console.error("Failed to fetch screen mapping files", err);
          setScreenOptions([]);
        });
    } else {
      setScreenOptions([]);
    }
  };

  const handleOrgChange = (event, newValue) => {
    setSelectedOrg(newValue);
    setSelectedScreen(null);
    if (newValue && typeof newValue !== 'string' && selectedTenant && selectedTenant.Tenant_ID) {
      const orgId = newValue["Organization ID"];
      if (orgId) {
        getRequest(`api/edureka/getScreenMappingFiles?tenantId=${selectedTenant.Tenant_ID}&orgId=${orgId}`)
          .then(res => {
            let data = res?.res?.data || res?.data || res;
            if (typeof data === 'string') {
              try { data = JSON.parse(data); } catch (e) {}
            }
            setScreenOptions(Array.isArray(data) ? data : []);
          })
          .catch(err => {
            console.error("Failed to fetch screen mapping files", err);
            setScreenOptions([]);
          });
      }
    } else {
      setScreenOptions([]);
    }
  };

  const handleSearchClick = () => {
    if (onSearch) {
      if (selectedTenant && selectedScreen) {
        onSearch({
          tenantId: selectedTenant.Tenant_ID,
          screenName: selectedScreen
        });
      } else {
        // We could show a toast here, but for now just pass false if incomplete
        onSearch(false);
      }
    }
  };

  return (
    <Box className="schema-filters-card">
      <Box className="schema-filters-row" sx={{ display: 'flex', gap: 2, alignItems: 'flex-end' }}>
        <Box className="filter-group" sx={{ flex: 1 }}>
          <Autocomplete
            freeSolo
            options={tenants}
            getOptionLabel={(option) => typeof option === 'string' ? option : `${option?.Organisation}-${option?.Tenant_ID}`}
            value={selectedTenant}
            onChange={handleTenantChange}
            renderInput={(params) => (
              <TextField
                {...params}
                fullWidth
                size="small"
                variant="outlined"
                label="Select Tenant ID"
                placeholder="Enter Tenant ID..."
                className="filter-input"
              />
            )}
          />
        </Box>
        {/* 
        <Box className="filter-group" sx={{ flex: 1 }}>
          <Autocomplete
            freeSolo
            options={orgOptions}
            getOptionLabel={(option) => typeof option === 'string' ? option : `${option?.["Organization Name"]}-${option?.["Organization ID"]}`}
            value={selectedOrg}
            onChange={handleOrgChange}
            renderInput={(params) => (
              <TextField
                {...params}
                fullWidth
                size="small"
                variant="outlined"
                label="Select Organization Name"
                placeholder="Enter Organization..."
                className="filter-input"
              />
            )}
          />
        </Box> 
        */}
        <Box className="filter-group" sx={{ flex: 1 }}>
          <Autocomplete
            freeSolo
            options={screenOptions}
            value={selectedScreen}
            onChange={(e, val) => setSelectedScreen(val)}
            renderInput={(params) => (
              <TextField
                {...params}
                fullWidth
                size="small"
                variant="outlined"
                label="Select Screen Name"
                placeholder="Enter Screen Name..."
                className="filter-input"
              />
            )}
          />
        </Box>
        <Box className="filter-group action-group" sx={{ pb: 0.25, display: 'flex', gap: 1 }}>
          <Button
            variant="contained"
            startIcon={<Search />}
            className="filter-search-btn"
            disableElevation
            onClick={handleSearchClick}
            size="small"
            sx={{ whiteSpace: 'nowrap', py: 0.25, px: 1.5, fontSize: '0.75rem', height: 32, borderRadius: 2 }}
          >
            Search
          </Button>
          {(selectedTenant && selectedScreen) && extraActions}
        </Box>
      </Box>
    </Box>
  );
};

export default FilterSection;
